import {styled} from '@linaria/react';
import React from 'react';
import {Text, TextProps} from './Text';

type RichTextProps = Omit<TextProps, 'children' | 'dangerouslySetInnerHTML'> & {
  id?: string;
  children: string;
};

export const RichText: React.FC<RichTextProps> = ({children, ...rest}) => {
  return <StyledText {...rest} dangerouslySetInnerHTML={{__html: children}} />;
};

const StyledText = styled(Text)`
  white-space: pre-wrap;
`;
